import { buildComponent } from '#components'

interface SingleProductSetting {
  id: number;
  a?: string,
  g?: string;
  n?: string;
}

declare global {
  interface Window {
    pn?: {
      settings: {
        singleProductSettings: SingleProductSetting[]
      }
    }
  }
}

const PreOrderMessage = buildComponent({
  name: 'pre-order-message',
  onConnected: (component) => {
    const productForm = document.querySelector('.js-product-form')
    const preorderNote = document.querySelector('#preorder-note')
    const preOrderButton = document.querySelector('.js-buy-buttons button:first-child[type=submit]')
    const shopifyPaymentButton = document.querySelector('.js-buy-buttons div[data-shopify="payment-button"]')
    const selectedVariantId = JSON.parse(document.querySelector("script[data-variant]")?.textContent || "{}").id

    if (window.pn) {
      const singleProductSettings = window.pn.settings.singleProductSettings

      const variant = singleProductSettings.find(
        (variant) => variant.n === String(selectedVariantId)
      )

      const message = variant?.g
      const preOrderButtonText = variant?.a

      if (component && message) {
        component.innerHTML = `<div class="tw-mt-3">${message}</div>`
      }

      if (preOrderButton && preOrderButtonText) preOrderButton.innerHTML = preOrderButtonText

      if (shopifyPaymentButton && preOrderButtonText) shopifyPaymentButton.classList.add('tw-hidden')

      if (productForm && !preorderNote) {
        const hiddenInput = document.createElement('input')
        hiddenInput.type = 'hidden'
        hiddenInput.id = 'preorder-note'
        hiddenInput.name = 'properties[PN-Note]'
        if (typeof message === "string") {
          hiddenInput.value = message
        }

        productForm.appendChild(hiddenInput)
      }
    }
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'pre-order-message': typeof PreOrderMessage
  }
}
